<script lang="ts">
    import BBCodeTree from '$components/BBCode/BBCodeTree.svelte';
    import { parseBBcode } from '$lib/bbcode/parseBBcode';
    import { getContainer } from '$components/Context/ContainerContext';
    import { CountryUseCurrent, type UrlCountry } from '$lib/UrlHelper';

    export let bbcode: string;
    export let replaceDpap = true;
    export let country: UrlCountry = CountryUseCurrent;

    const { dpapHelper, countryHelper } = getContainer();

    $: resolvedCountry = countryHelper().resolveCountry(country);
    $: nodes = parseBBcode(
        replaceDpap ? dpapHelper().replaceDpAp($resolvedCountry, bbcode) : bbcode,
    );
</script>

<BBCodeTree {nodes} let:slotName let:slotContent>
    <slot {slotName} {slotContent} />
</BBCodeTree>
